import { MINIMUM_CASH_DOWN_THRESHOLD } from '../constants';

/**
 * Checks if a given variable is empty.
 * Supports strings, arrays, objects, Maps, Sets, and null/undefined.
 *
 * @param value - The variable to check.
 * @returns True if the variable is empty, false otherwise.
 */
export function isEmpty(value: any): boolean {
    if (value == null) return true;
    if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
    if (value instanceof Map || value instanceof Set) return value.size === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
}

export const replaceArrayValue = <T = string>(array: T[], oldEl: T, newEl: T): T[] => {
    if (oldEl === newEl) return [...array];

    const index = array.findIndex((item) => Object.is(item, oldEl));
    if (index === -1) return [...array, newEl];
    return [...array.slice(0, index), newEl, ...array.slice(index + 1)];
};

export const isExpectedDownPayment = (oldValue: number, newValue: number): boolean => {
    return oldValue < newValue - MINIMUM_CASH_DOWN_THRESHOLD;
};
